/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Inbound_Waiting_On_RestInputs */

const en_inbound_waiting_on_rest = /** @type {(inputs: Inbound_Waiting_On_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting for the rest of the goods · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting for the rest of the goods · since {since}" |
*
* @param {Inbound_Waiting_On_RestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_rest = /** @type {((inputs: Inbound_Waiting_On_RestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_RestInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_rest(inputs)
});